exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container-content[data-v-53ba8ce7]{\r\n  padding-bottom: 20px !important;\n}\r\n", ""]);

// exports
